import { render, staticRenderFns } from "./EncyclopediaHeader.vue?vue&type=template&id=49f0679d&scoped=true&"
import script from "./EncyclopediaHeader.vue?vue&type=script&lang=js&"
export * from "./EncyclopediaHeader.vue?vue&type=script&lang=js&"
import style0 from "./EncyclopediaHeader.vue?vue&type=style&index=0&id=49f0679d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f0679d",
  null
  
)

export default component.exports